import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  PaymentRequestUrlInvalidComponent
} from '../payments/payment-request-url-invalid/payment-request-url-invalid.component';
import { PaymentRedirectedComponent } from './payment-redirected/payment-redirected.component';
import { PaymentSelectionComponent } from './payment-selection/payment-selection.component';
import { HostedPaymentRequestComponent } from './hosted-payment-request/hosted-payment-request.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'payment-redirected',
        component: PaymentRedirectedComponent,
        data: {
          title: 'Payment Redirected'
        }
      },
      {
        path: 'payment-request-url-invalid',
        component: PaymentRequestUrlInvalidComponent,
        data: {
          title: 'Payment Request Url Invalid'
        }
      },
      {
        path: 'payment-request/:authorizationCode',
        component: HostedPaymentRequestComponent,
        data: {
          title: 'Payment Request'
        }
      },
      {
        path: ':companySlug/:slug',
        component: PaymentSelectionComponent,
        data: {
          title: 'Payment Selection'
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PaymentsRoutingModule {
}
